import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/flights/search.ts
import { Exception } from "@wbk/logger";
var searchFlights = (search) => __async(void 0, null, function* () {
  try {
    const data = yield fetchClient({
      url: "/flights/search",
      version: "v1",
      options: {
        method: "POST",
        body: JSON.stringify(search)
      }
    });
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "searchFlightsException"
    });
  }
});

export {
  searchFlights
};
//# sourceMappingURL=chunk-4G3V5H6E.mjs.map